const translations = {
  de: {
    // ===== COMMON =====
    back: 'Zurück',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    optional: 'optional',
    sending: 'Sende...',
    moreInfo: 'Weitere Informationen',
    close: 'Schliessen',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    contact: 'Kontakt',

    // ===== PROGRESS BAR =====
    stepPLZ: 'PLZ',
    stepProject: 'Projekt',
    stepDemand: 'Bedarf',
    stepDetails: 'Details',
    stepResult: 'Ergebnis',
    stepContact: 'Kontakt',

    // ===== LANDING PAGE =====
    heroTitle: 'Finden Sie die günstigste Erdwärmelösung – jetzt Kosten abschätzen',
    heroSubtitle: 'Wenige Klicks bis zum Angebot, das mit Luftwärmepumpen mithalten kann.',
    ctaButton: 'Jetzt Kosten abschätzen',
    uspTitle1: 'Bis zu 30 % günstiger',
    uspText1: 'Dank innovativer Erdwärmelösungen und direktem Kontakt zu Fachbetrieben',
    uspTitle2: 'Höchste Effizienz',
    uspText2: 'Geringere Betriebskosten als Luftwärmepumpen durch konstante Erdtemperatur',
    uspTitle3: 'Regionale Partner',
    uspText3: 'Partnerbetriebe für professionelle Beratung und zuverlässige Umsetzung',
    moreAdvantages: 'Weitere Vorteile:',
    moreAdvantagesText: 'Keine Lärmbelastung, längere Lebensdauer der Wärmepumpe, Aufwertung der Liegenschaft, Free-Cooling',
    whyGeoTitle: 'Warum Erdwärme?',
    whyGeoText1: 'Erdwärme nutzt die konstante Temperatur des Erdreichs – zuverlässig, effizient und nachhaltig. Im Gegensatz zu Luftwärmepumpen, die bei kalten Temperaturen an Effizienz verlieren, liefert Erdwärme das ganze Jahr über konstante Leistung.',
    whyGeoText2: 'Mit modernen Bohrtechniken und innovativen Systemen wird die Installation immer kostengünstiger und einfacher.',

    // ===== STEP 1 - PLZ =====
    step1Title: 'Ihre Postleitzahl',
    step1Desc: 'Prüfen Sie, ob Erdwärme in Ihrer Region verfügbar ist.',
    plzLabel: 'Postleitzahl*',
    plzPlaceholder: 'z.B. 8000',
    plzChecking: 'Prüfe Verfügbarkeit...',
    plzMultipleFound: 'Mehrere Orte gefunden - Bitte wählen Sie:',
    plzAvailable: 'Verfügbar',
    plzNotAvailable: 'Nicht verfügbar',
    plzRegionAvailable: 'Region verfügbar – weiter zur Berechnung',
    plzCurrentlyUnavailable: 'Derzeit nicht verfügbar',
    plzUnavailableText: 'Tragen Sie sich ein, wir informieren Sie, sobald der Erdwärmerechner für Ihre Region verfügbar ist.',
    plzAllUnavailableText: 'Diese PLZ ist in keiner Region verfügbar. Tragen Sie sich ein:',
    plzJoinWaitlist: 'Auf Warteliste setzen',
    plzProceed: 'Weiter zur Berechnung',
    // Waitlist
    waitlistName: 'Name*',
    waitlistNamePlaceholder: 'Ihr Name',
    waitlistEmail: 'E-Mail*',
    waitlistEmailPlaceholder: 'ihre@email.com',
    waitlistConsent: 'Ich akzeptiere die',
    waitlistPrivacyLink: 'Datenschutzerklärung',
    waitlistSubmit: 'Auf Warteliste eintragen',
    waitlistSuccess: 'Vielen Dank! Wir informieren Sie, sobald Ihre Region verfügbar ist.',

    // ===== STEP 2 - PROJECT =====
    step2Title: 'Ihr Projekt',
    step2Desc: 'Was planen Sie?',
    projectTypeLabel: 'Projekttyp*',
    projectNeubau: 'Neubau',
    projectTausch: 'Tausch/Sanierung',
    buildingTypeLabel: 'Gebäudetyp*',
    buildingEfh: 'Einfamilienhaus',
    buildingMfh: 'Mehrfamilienhaus',
    buildingSonstig: 'Sonstiges',
    buildingTypeOtherLabel: 'Gebäudetyp angeben*',
    buildingTypeOtherPlaceholder: 'z.B. Industriegebäude, Lagerhalle...',
    buildingTypeOtherCount: 'Zeichen',
    buildingTypeOtherError: 'Bitte geben Sie den Gebäudetyp an',

    // ===== STEP 3 - DEMAND =====
    step3Title: 'Wärmebedarf',
    step3Desc: 'Helfen Sie uns, Ihren Energiebedarf zu schätzen.',
    energyConsumptionLabel: 'Energieverbrauch (kWh/Jahr)*',
    energyConsumptionPlaceholder: 'z.B. 15000',
    energyIncludesHotWater: 'Ist dieser Energieverbrauch inkl. Warmwasser?*',
    personsLabel: 'Anzahl Personen im Haushalt*',
    personsPlaceholder: 'z.B. 4',
    hotWaterQuestion: 'Soll die Erdwärme auch Warmwasser heizen?*',
    areaLabel: 'Wohnfläche (m²)',
    areaPlaceholder: 'z.B. 150',
    altitudeLabel: 'Meereshöhe (m)',
    altitudePlaceholder: 'Standard: 500 m',
    freeCoolingLabel: 'Free Cooling gewünscht?',
    prevSystemLabel: 'Bisheriges Heizsystem*',
    prevSystemPlaceholder: 'Bitte wählen',
    prevSystemOel: 'Öl',
    prevSystemGas: 'Gas',
    prevSystemElektro: 'Elektrospeicher',
    prevSystemHolz: 'Holz',
    prevSystemLuftWp: 'Luft-Wärmepumpe',
    energyConsumptionDynamicLabel: 'Energieverbrauch',
    // Energy units
    energyUnitOel: 'Liter/Jahr',
    energyUnitGas: 'm³/Jahr',
    energyUnitElektro: 'kWh Strom/Jahr',
    energyUnitHolz: 'm³ Raummeter/Jahr',
    energyUnitLuftWp: 'kWh erzeugte Wärmeenergie/Jahr',
    energyUnitDefault: 'Einheit/Jahr',
    // Validation
    valEnergyRequired: 'Bitte geben Sie den Energieverbrauch ein',
    valEnergyInclHwRequired: 'Bitte geben Sie an, ob der Energieverbrauch Warmwasser beinhaltet',
    valPersonsRequired: 'Bitte geben Sie die Anzahl der Personen ein',
    valHotWaterRequired: 'Bitte wählen Sie, ob die Erdwärme auch Warmwasser heizen soll',
    valPrevSystemRequired: 'Bitte wählen Sie Ihr bisheriges Heizsystem aus',

    // ===== STEP 4 - DETAILS =====
    step4Title: 'Details',
    step4Desc: 'Wann möchten Sie starten?',
    timeframeLabel: 'Zeitpunkt*',
    timeframeSofort: 'Sofort',
    timeframeNachRuecksprache: 'Nach Rücksprache',
    timeframe3_6: 'In 3-6 Monaten',
    timeframe6_12: 'In 6-12 Monaten',
    timeframeOver12: 'Über 12 Monate',
    subsidyLabel: 'Förderungen',
    subsidyErdwaermeLabel: 'Förderung Erdwärme',
    subsidyLuftwaermeLabel: 'Förderung Luftwärme',
    subsidyPlaceholder: 'z.B. 10000',
    subsidyLuftPlaceholder: 'z.B. 5000',
    calculateBtn: 'Kosten berechnen',
    calculating: 'Berechne...',

    // ===== STEP 5 - RESULTS =====
    resultTitle: 'Ihre Kostenabschätzung',
    resultSubtitle: 'Vergleich der drei Heizsysteme',
    fullCostComparison: 'Vollkostenvergleich über 25 Jahre',
    fullCostTooltip: 'Die Vollkosten beinhalten die anteilsmässigen Kosten aus der Investition und Betrieb über 25 Jahre.',
    legendInvest: 'Investitionskosten',
    legendRenewal: 'Anteilsmässige Kosten Ersatz Wärmepumpe',
    legendOperation: 'Betriebskosten (25 Jahre)',
    fullCostIn: 'Vollkosten in',
    savingsTitle: 'Einsparung Vollkosten separatus vs. Luftwärme',
    systemSeparatus: 'Erdwärmepumpe mit separatus Sondensystem',
    systemKonv: 'Erdwärmepumpe mit herkömmlichem Sondensystem',
    systemLuft: 'Luftwärmepumpensystem',
    systemSeparatusShort: 'Erdwärmepumpe mit separatus',
    systemKonvShort: 'Erdwärmepumpe mit herkömmlichem Sondensystem',
    systemLuftShort: 'Luftwärmepumpensystem',
    investPlusRenewal: 'Investitionskosten + Anteilsmässige Kosten Ersatz Wärmepumpe:',
    operatingCostsPerYear: 'Betriebskosten pro Jahr:',
    separatusInvestTooltip1: 'Die anteiligen Investitionskosten bestehen aus:',
    separatusInvestTooltip2: 'Kosten für das Erdsondensystem inklusive Bohrung. Das System hat eine Lebensdauer von über 50 Jahren!',
    separatusInvestTooltip3: 'Erdwärmepumpe inklusive Anschluss.',
    separatusInvestTooltip4: 'Ersatz Erdwärmepumpe nach 23 Jahren, da sie innerhalb des Betrachtungszeitraums ersetzt werden muss.',
    luftInvestTooltip1: 'Die anteiligen Investitionskosten bestehen aus:',
    luftInvestTooltip2: 'Luftwärmepumpe inklusive Anschluss.',
    luftInvestTooltip3: 'Ersatz Luftwärmepumpe nach 16 Jahren, da sie innerhalb des Betrachtungszeitraums ersetzt werden muss.',
    // Table
    tableOverview: 'Übersicht aller Systeme',
    tableSeparatus: 'separatus',
    tableKonv: 'Herkömmlich',
    tableLuft: 'Luftwärmepumpe',
    tableFullCost: 'Vollkosten (25 Jahre)',
    tableInvestCost: 'Investitionskosten',
    tableInvestTooltip: 'Investitionskosten entstehen zu Projektbeginn an und beinhalten die folgenden Positionen:\n\n- Luftwärme: Wärmepumpe inkl. Anschluss.\n- Erdwärme: Wärmepumpe inkl. Anschluss, Bohrung & Erdsondensystem',
    tableRenewalCost: 'Erneuerungskosten',
    tableRenewalTooltip: 'Erneuerungskosten fallen an, wenn die Wärmepumpe ersetzt werden muss.\n\n- Bei Erdwärme nach 23 Jahren\n- Bei Luftwärme nach 16 Jahren',
    tableOperatingYear: 'Betriebskosten / Jahr',
    tableOperating25: 'Betriebskosten (25 Jahre)',
    // Project details
    projectDetails: 'Projektdetails',
    detailLocation: 'Ort',
    detailEnergyConsumption: 'Energieverbrauch in kWh / Jahr',
    detailHotWater: 'Warmwasser',
    detailHeatingPowerGeo: 'Heizleistung Erdwärmepumpe in kW',
    detailHeatingPowerAir: 'Heizleistung Luftwärmepumpe in kW',
    detailSubsidyGeo: 'Förderung Erdwärme',
    detailSubsidyAir: 'Förderung Luftwärme',
    resultDisclaimer: 'Hinweis: Die angegebenen Werte dienen der Orientierung und stellen kein verbindliches Angebot dar. Die tatsächlichen Kosten können je nach Standort und individuellen Anforderungen variieren.',
    requestOffer: 'Angebot anfragen',

    // ===== STEP 6 - CONTACT =====
    step6Title: 'Ihre Kontaktdaten',
    step6Desc: 'Erhalten Sie Ihr individuelles Angebot per E-Mail.',
    nameLabel: 'Name*',
    namePlaceholder: 'Max Mustermann',
    emailLabel: 'E-Mail*',
    emailPlaceholder: 'max@example.com',
    phoneLabel: 'Telefon*',
    phonePlaceholder: '+41 79 123 45 67',
    addressLabel: 'Adresse',
    addressOptional: 'Optional - Für genauere Berechnung',
    addressPlaceholder: 'Musterstrasse 1, Zürich',
    addressTip: 'Tipp: Für beste Ergebnisse Straße + Ort eingeben (z.B. "Goststraße 37a, Altach")',
    addressCheck: 'Adresse überprüfen',
    addressCheckTitle: 'Adresse überprüfen',
    addressDidYouMean: 'Meinten Sie:',
    addressYesAccept: 'Ja, übernehmen',
    addressNoCorrect: 'Nein, meine Eingabe ist korrekt',
    addressNotFound: 'Adresse konnte nicht gefunden werden. Bitte überprüfen Sie die Eingabe.',
    addressOkCorrect: 'OK, ich korrigiere',
    addressOnMap: 'Adresse auf Karte',
    addressMapCentered: 'Karte zentriert auf:',
    addressMapWaiting: 'Karte wird zentriert sobald eine Adresse aus den Vorschlägen ausgewählt wird.',
    installerQuestion: 'Haben Sie bereits einen Heizungsinstallateur?',
    installerInfoLabel: 'Firma / Webseite des Installateurs',
    installerInfoPlaceholder: 'z.B. Musterfirma GmbH oder www.beispiel.ch',
    noInstallerHint: 'Kein Problem, wir finden einen passenden Installateur für Sie.',
    additionalInfoLabel: 'Zusätzliche Informationen',
    additionalInfoPlaceholder: 'Teilen Sie uns weitere Details zu Ihrem Projekt mit...',
    fileUploadLabel: 'Dokumente hochladen (optional)',
    fileUploadDesc: 'PDF, JPG, PNG - max. 3 Dateien, je max. 10 MB',
    fileUploadDrag: 'Klicken oder Dateien hierher ziehen',
    fileUploadDragging: 'Dateien hier ablegen...',
    consentText: 'Ich akzeptiere die',
    consentLink: 'Datenschutzerklärung',
    consentSuffix: 'und stimme der Verarbeitung meiner Daten zu.*',
    submitBtn: 'Anfrage absenden',
    submitHint: 'Mit dem Absenden wird Ihre Kostenabschätzung als PDF heruntergeladen.',

    // ===== INFO POPUP =====
    infoPopupTitle: 'Weitere Informationen',

    // ===== TOAST MESSAGES =====
    // Common
    toastSaveError: 'Fehler beim Speichern',
    toastDeleteError: 'Fehler beim Löschen',
    // api.js
    toastCalcError: 'Fehler bei Berechnung',
    toastConsentRequired: 'Bitte akzeptieren Sie die Datenschutzerklärung',
    toastSubmitSuccess: 'Ihre Anfrage wurde erfolgreich übermittelt!',
    toastSubmitError: 'Fehler beim Senden der Anfrage',
    toastPdfCreating: 'PDF wird erstellt...',
    toastPdfSuccess: 'PDF wurde heruntergeladen',
    toastPdfError: 'Fehler beim Erstellen des PDFs',
    toastInfoLoadError: 'Fehler beim Laden der Informationen',
    pdfSeeAppendix: '(Siehe Anhang)',
    pdfAppendixTitle: 'Anhang: Weitere Informationen',
    pdfFileName: 'Kostenabschaetzung',
    // Calculator
    toastNameEmailRequired: 'Bitte Name und E-Mail eingeben',
    toastWaitlistError: 'Fehler beim Eintragen in die Warteliste',
    toastPlzRequired: 'Bitte geben Sie eine verfügbare PLZ ein',
    // File Upload
    toastMaxFiles: 'Maximal {n} Dateien erlaubt',
    toastFileTypeError: 'Nur PDF, JPG und PNG Dateien erlaubt',
    toastFileSizeError: 'Dateien dürfen maximal {n} MB groß sein',
    toastFilesAdded: '{n} Datei(en) hinzugefügt',
    // Admin Login
    toastLoginSuccess: 'Login erfolgreich!',
    // Admin Profile
    toastProfileLoadError: 'Fehler beim Laden des Profils',
    toastProfileUpdated: 'Profil aktualisiert',
    // Admin Users
    toastNoPermission: 'Keine Berechtigung',
    toastUsersLoadError: 'Fehler beim Laden der Benutzer',
    toastUserUpdated: 'Benutzer aktualisiert',
    toastPasswordRequired: 'Passwort ist erforderlich',
    toastUserCreated: 'Benutzer erstellt',
    toastUserDeleted: 'Benutzer gelöscht',
    // Admin Dashboard
    toastSessionExpired: 'Sitzung abgelaufen. Bitte erneut anmelden.',
    toastLeadsLoadError: 'Fehler beim Laden der Leads',
    toastLogoutSuccess: 'Erfolgreich abgemeldet',
    toastCsvSuccess: 'CSV Export erfolgreich',
    toastCsvError: 'Fehler beim CSV Export',
    // Admin Settings
    toastConfigLoadError: 'Fehler beim Laden der Konfiguration',
    toastCalcLogicSaved: 'Berechnungslogik erfolgreich gespeichert',
    toastCalcLogicError: 'Fehler beim Speichern der Berechnungslogik',
    toastInfoTextSaved: 'Informationstext gespeichert!',
    toastEmailTemplatesSaved: 'E-Mail Templates erfolgreich gespeichert',
    toastTestEmailRequired: 'Bitte E-Mail-Adresse für Test eingeben',
    toastTestEmailSent: 'Test-E-Mail für {key} gesendet an {email}',
    toastTestEmailError: 'Fehler beim Senden der Test-E-Mail',
    toastConfigSaved: 'Konfiguration erfolgreich gespeichert',
    toastConfigRestored: 'Konfiguration wiederhergestellt',
    toastResetError: 'Fehler beim Zurücksetzen',
    toastPlzInvalidChars: 'Nur Kommas als Trennzeichen erlaubt! Ungültige Zeichen gefunden: {chars}',
    toastPlzInvalidPrefixes: 'Ungültige PLZ-Präfixe (nur Zahlen erlaubt): {prefixes}',
    toastPlzUpdated: 'PLZ-Präfixe für {country} aktualisiert',
    toastDefaultLogicLoaded: 'Standard-Logik geladen und gespeichert',
    toastSaveErrorDetail: 'Fehler beim Speichern: {detail}',
    // Admin Lead Detail
    toastLeadLoadError: 'Fehler beim Laden des Leads',
    toastLeadUpdated: 'Lead erfolgreich aktualisiert',
    toastUpdateError: 'Fehler beim Aktualisieren',
    toastEmailSent: 'E-Mail versendet und Status aktualisiert',
    toastEmailSendError: 'Fehler beim Versenden der E-Mail',
    toastLeadConverted: 'Lead erfolgreich umgewandelt',
    toastConvertError: 'Fehler beim Umwandeln des Leads',
    toastPlzMismatch: 'PLZ stimmt nicht überein!',
    toastLeadDeleted: 'Lead erfolgreich gelöscht',
    toastLeadDeleteError: 'Fehler beim Löschen des Leads',
    toastReloginRequired: 'Bitte melden Sie sich erneut an',
    toastFileDownloadError: 'Fehler beim Herunterladen der Datei',
  },

  en: {
    // ===== COMMON =====
    back: 'Back',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    optional: 'optional',
    sending: 'Sending...',
    moreInfo: 'More information',
    close: 'Close',
    allRightsReserved: 'All rights reserved.',
    imprint: 'Imprint',
    privacy: 'Privacy Policy',
    contact: 'Contact',

    // ===== PROGRESS BAR =====
    stepPLZ: 'Postal Code',
    stepProject: 'Project',
    stepDemand: 'Demand',
    stepDetails: 'Details',
    stepResult: 'Result',
    stepContact: 'Contact',

    // ===== LANDING PAGE =====
    heroTitle: 'Find the most affordable geothermal solution – estimate costs now',
    heroSubtitle: 'Just a few clicks to an offer that competes with air-source heat pumps.',
    ctaButton: 'Estimate costs now',
    uspTitle1: 'Up to 30% cheaper',
    uspText1: 'Thanks to innovative geothermal solutions and direct contact with specialist companies',
    uspTitle2: 'Maximum efficiency',
    uspText2: 'Lower operating costs than air-source heat pumps due to constant ground temperature',
    uspTitle3: 'Regional partners',
    uspText3: 'Partner companies for professional advice and reliable implementation',
    moreAdvantages: 'More advantages:',
    moreAdvantagesText: 'No noise pollution, longer heat pump lifespan, property value increase, free cooling',
    whyGeoTitle: 'Why geothermal energy?',
    whyGeoText1: 'Geothermal energy uses the constant temperature of the ground – reliable, efficient and sustainable. Unlike air-source heat pumps that lose efficiency in cold temperatures, geothermal energy delivers consistent performance all year round.',
    whyGeoText2: 'With modern drilling techniques and innovative systems, installation is becoming more affordable and simpler.',

    // ===== STEP 1 - PLZ =====
    step1Title: 'Your postal code',
    step1Desc: 'Check if geothermal energy is available in your region.',
    plzLabel: 'Postal code*',
    plzPlaceholder: 'e.g. 8000',
    plzChecking: 'Checking availability...',
    plzMultipleFound: 'Multiple locations found - Please select:',
    plzAvailable: 'Available',
    plzNotAvailable: 'Not available',
    plzRegionAvailable: 'Region available – proceed to calculation',
    plzCurrentlyUnavailable: 'Currently unavailable',
    plzUnavailableText: 'Sign up and we will notify you as soon as the calculator is available for your region.',
    plzAllUnavailableText: 'This postal code is not available in any region. Sign up:',
    plzJoinWaitlist: 'Join waitlist',
    plzProceed: 'Proceed to calculation',
    // Waitlist
    waitlistName: 'Name*',
    waitlistNamePlaceholder: 'Your name',
    waitlistEmail: 'Email*',
    waitlistEmailPlaceholder: 'your@email.com',
    waitlistConsent: 'I accept the',
    waitlistPrivacyLink: 'Privacy Policy',
    waitlistSubmit: 'Join waitlist',
    waitlistSuccess: 'Thank you! We will notify you as soon as your region becomes available.',

    // ===== STEP 2 - PROJECT =====
    step2Title: 'Your project',
    step2Desc: 'What are you planning?',
    projectTypeLabel: 'Project type*',
    projectNeubau: 'New build',
    projectTausch: 'Replacement/Renovation',
    buildingTypeLabel: 'Building type*',
    buildingEfh: 'Single-family house',
    buildingMfh: 'Multi-family house',
    buildingSonstig: 'Other',
    buildingTypeOtherLabel: 'Specify building type*',
    buildingTypeOtherPlaceholder: 'e.g. Industrial building, warehouse...',
    buildingTypeOtherCount: 'characters',
    buildingTypeOtherError: 'Please specify the building type',

    // ===== STEP 3 - DEMAND =====
    step3Title: 'Heating demand',
    step3Desc: 'Help us estimate your energy requirements.',
    energyConsumptionLabel: 'Energy consumption (kWh/year)*',
    energyConsumptionPlaceholder: 'e.g. 15000',
    energyIncludesHotWater: 'Does this energy consumption include hot water?*',
    personsLabel: 'Number of persons in household*',
    personsPlaceholder: 'e.g. 4',
    hotWaterQuestion: 'Should geothermal also heat hot water?*',
    areaLabel: 'Living area (m²)',
    areaPlaceholder: 'e.g. 150',
    altitudeLabel: 'Altitude (m)',
    altitudePlaceholder: 'Default: 500 m',
    freeCoolingLabel: 'Free cooling desired?',
    prevSystemLabel: 'Previous heating system*',
    prevSystemPlaceholder: 'Please select',
    prevSystemOel: 'Oil',
    prevSystemGas: 'Gas',
    prevSystemElektro: 'Electric storage heater',
    prevSystemHolz: 'Wood',
    prevSystemLuftWp: 'Air-source heat pump',
    energyConsumptionDynamicLabel: 'Energy consumption',
    // Energy units
    energyUnitOel: 'Liters/year',
    energyUnitGas: 'm³/year',
    energyUnitElektro: 'kWh electricity/year',
    energyUnitHolz: 'm³ stacked wood/year',
    energyUnitLuftWp: 'kWh generated heat energy/year',
    energyUnitDefault: 'Unit/year',
    // Validation
    valEnergyRequired: 'Please enter the energy consumption',
    valEnergyInclHwRequired: 'Please indicate whether energy consumption includes hot water',
    valPersonsRequired: 'Please enter the number of persons',
    valHotWaterRequired: 'Please select whether geothermal should also heat hot water',
    valPrevSystemRequired: 'Please select your previous heating system',

    // ===== STEP 4 - DETAILS =====
    step4Title: 'Details',
    step4Desc: 'When would you like to start?',
    timeframeLabel: 'Timeframe*',
    timeframeSofort: 'Immediately',
    timeframeNachRuecksprache: 'After consultation',
    timeframe3_6: 'In 3-6 months',
    timeframe6_12: 'In 6-12 months',
    timeframeOver12: 'Over 12 months',
    subsidyLabel: 'Subsidies',
    subsidyErdwaermeLabel: 'Subsidy geothermal',
    subsidyLuftwaermeLabel: 'Subsidy air-source',
    subsidyPlaceholder: 'e.g. 10000',
    subsidyLuftPlaceholder: 'e.g. 5000',
    calculateBtn: 'Calculate costs',
    calculating: 'Calculating...',

    // ===== STEP 5 - RESULTS =====
    resultTitle: 'Your cost estimate',
    resultSubtitle: 'Comparison of three heating systems',
    fullCostComparison: 'Total cost comparison over 25 years',
    fullCostTooltip: 'Total costs include the proportional costs from investment and operation over 25 years.',
    legendInvest: 'Investment costs',
    legendRenewal: 'Proportional heat pump replacement costs',
    legendOperation: 'Operating costs (25 years)',
    fullCostIn: 'Total costs in',
    savingsTitle: 'Total cost savings separatus vs. air-source',
    systemSeparatus: 'Geothermal heat pump with separatus probe system',
    systemKonv: 'Geothermal heat pump with conventional probe system',
    systemLuft: 'Air-source heat pump system',
    systemSeparatusShort: 'Geothermal with separatus',
    systemKonvShort: 'Geothermal with conventional probe system',
    systemLuftShort: 'Air-source heat pump system',
    investPlusRenewal: 'Investment costs + Proportional heat pump replacement costs:',
    operatingCostsPerYear: 'Operating costs per year:',
    separatusInvestTooltip1: 'The proportional investment costs consist of:',
    separatusInvestTooltip2: 'Costs for the geothermal probe system including drilling. The system has a lifespan of over 50 years!',
    separatusInvestTooltip3: 'Geothermal heat pump including connection.',
    separatusInvestTooltip4: 'Replacement of geothermal heat pump after 23 years, as it must be replaced within the observation period.',
    luftInvestTooltip1: 'The proportional investment costs consist of:',
    luftInvestTooltip2: 'Air-source heat pump including connection.',
    luftInvestTooltip3: 'Replacement of air-source heat pump after 16 years, as it must be replaced within the observation period.',
    // Table
    tableOverview: 'Overview of all systems',
    tableSeparatus: 'separatus',
    tableKonv: 'Conventional',
    tableLuft: 'Air-source',
    tableFullCost: 'Total costs (25 years)',
    tableInvestCost: 'Investment costs',
    tableInvestTooltip: 'Investment costs are incurred at the start of the project and include:\n\n- Air-source: Heat pump incl. connection.\n- Geothermal: Heat pump incl. connection, drilling & probe system',
    tableRenewalCost: 'Renewal costs',
    tableRenewalTooltip: 'Renewal costs are incurred when the heat pump needs to be replaced.\n\n- Geothermal after 23 years\n- Air-source after 16 years',
    tableOperatingYear: 'Operating costs / year',
    tableOperating25: 'Operating costs (25 years)',
    // Project details
    projectDetails: 'Project details',
    detailLocation: 'Location',
    detailEnergyConsumption: 'Energy consumption in kWh / year',
    detailHotWater: 'Hot water',
    detailHeatingPowerGeo: 'Heating capacity geothermal heat pump in kW',
    detailHeatingPowerAir: 'Heating capacity air-source heat pump in kW',
    detailSubsidyGeo: 'Subsidy geothermal',
    detailSubsidyAir: 'Subsidy air-source',
    resultDisclaimer: 'Note: The values shown are for guidance only and do not constitute a binding offer. Actual costs may vary depending on location and individual requirements.',
    requestOffer: 'Request offer',

    // ===== STEP 6 - CONTACT =====
    step6Title: 'Your contact details',
    step6Desc: 'Receive your personalized offer by email.',
    nameLabel: 'Name*',
    namePlaceholder: 'John Smith',
    emailLabel: 'Email*',
    emailPlaceholder: 'john@example.com',
    phoneLabel: 'Phone*',
    phonePlaceholder: '+41 79 123 45 67',
    addressLabel: 'Address',
    addressOptional: 'Optional - For more accurate calculation',
    addressPlaceholder: 'Main Street 1, Zurich',
    addressTip: 'Tip: For best results, enter street + city (e.g. "Goststraße 37a, Altach")',
    addressCheck: 'Verify address',
    addressCheckTitle: 'Verify address',
    addressDidYouMean: 'Did you mean:',
    addressYesAccept: 'Yes, accept',
    addressNoCorrect: 'No, my input is correct',
    addressNotFound: 'Address could not be found. Please check your input.',
    addressOkCorrect: 'OK, I\'ll correct it',
    addressOnMap: 'Address on map',
    addressMapCentered: 'Map centered on:',
    addressMapWaiting: 'Map will center once an address is selected from suggestions.',
    installerQuestion: 'Do you already have a heating installer?',
    installerInfoLabel: 'Company / website of the installer',
    installerInfoPlaceholder: 'e.g. Sample Company Ltd or www.example.ch',
    noInstallerHint: 'No problem, we\'ll find a suitable installer for you.',
    additionalInfoLabel: 'Additional information',
    additionalInfoPlaceholder: 'Share any additional details about your project...',
    fileUploadLabel: 'Upload documents (optional)',
    fileUploadDesc: 'PDF, JPG, PNG - max. 3 files, max. 10 MB each',
    fileUploadDrag: 'Click or drag files here',
    fileUploadDragging: 'Drop files here...',
    consentText: 'I accept the',
    consentLink: 'Privacy Policy',
    consentSuffix: 'and consent to the processing of my data.*',
    submitBtn: 'Submit request',
    submitHint: 'Upon submission, your cost estimate will be downloaded as a PDF.',

    // ===== INFO POPUP =====
    infoPopupTitle: 'More information',

    // ===== TOAST MESSAGES =====
    // Common
    toastSaveError: 'Error saving',
    toastDeleteError: 'Error deleting',
    // api.js
    toastCalcError: 'Calculation error',
    toastConsentRequired: 'Please accept the privacy policy',
    toastSubmitSuccess: 'Your request has been successfully submitted!',
    toastSubmitError: 'Error submitting request',
    toastPdfCreating: 'Creating PDF...',
    toastPdfSuccess: 'PDF downloaded',
    toastPdfError: 'Error creating PDF',
    toastInfoLoadError: 'Error loading information',
    pdfSeeAppendix: '(See appendix)',
    pdfAppendixTitle: 'Appendix: Further information',
    pdfFileName: 'Cost_Estimate',
    // Calculator
    toastNameEmailRequired: 'Please enter name and email',
    toastWaitlistError: 'Error joining waitlist',
    toastPlzRequired: 'Please enter a valid postal code',
    // File Upload
    toastMaxFiles: 'Maximum {n} files allowed',
    toastFileTypeError: 'Only PDF, JPG, and PNG files allowed',
    toastFileSizeError: 'Files must be smaller than {n} MB',
    toastFilesAdded: '{n} file(s) added',
    // Admin Login
    toastLoginSuccess: 'Login successful!',
    // Admin Profile
    toastProfileLoadError: 'Error loading profile',
    toastProfileUpdated: 'Profile updated',
    // Admin Users
    toastNoPermission: 'No permission',
    toastUsersLoadError: 'Error loading users',
    toastUserUpdated: 'User updated',
    toastPasswordRequired: 'Password is required',
    toastUserCreated: 'User created',
    toastUserDeleted: 'User deleted',
    // Admin Dashboard
    toastSessionExpired: 'Session expired. Please login again.',
    toastLeadsLoadError: 'Error loading leads',
    toastLogoutSuccess: 'Logged out successfully',
    toastCsvSuccess: 'CSV export successful',
    toastCsvError: 'CSV export error',
    // Admin Settings
    toastConfigLoadError: 'Error loading configuration',
    toastCalcLogicSaved: 'Calculation logic saved successfully',
    toastCalcLogicError: 'Error saving calculation logic',
    toastInfoTextSaved: 'Information text saved!',
    toastEmailTemplatesSaved: 'Email templates saved successfully',
    toastTestEmailRequired: 'Please enter email address for test',
    toastTestEmailSent: 'Test email for {key} sent to {email}',
    toastTestEmailError: 'Error sending test email',
    toastConfigSaved: 'Configuration saved successfully',
    toastConfigRestored: 'Configuration restored',
    toastResetError: 'Error resetting',
    toastPlzInvalidChars: 'Only commas allowed as separators! Invalid characters found: {chars}',
    toastPlzInvalidPrefixes: 'Invalid postal code prefixes (only numbers allowed): {prefixes}',
    toastPlzUpdated: 'Postal code prefixes for {country} updated',
    toastDefaultLogicLoaded: 'Default logic loaded and saved',
    toastSaveErrorDetail: 'Error saving: {detail}',
    // Admin Lead Detail
    toastLeadLoadError: 'Error loading lead',
    toastLeadUpdated: 'Lead updated successfully',
    toastUpdateError: 'Error updating',
    toastEmailSent: 'Email sent and status updated',
    toastEmailSendError: 'Error sending email',
    toastLeadConverted: 'Lead converted successfully',
    toastConvertError: 'Error converting lead',
    toastPlzMismatch: 'Postal code does not match!',
    toastLeadDeleted: 'Lead deleted successfully',
    toastLeadDeleteError: 'Error deleting lead',
    toastReloginRequired: 'Please login again',
    toastFileDownloadError: 'Error downloading file',
  }
};

export default translations;
